import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Button, Col, Container, Row, Modal, Form } from "react-bootstrap";
import { useHistory } from 'react-router-dom';
import { Button as StateButton, RouterStateButton } from '../forms/elements';
import Wrapper from '../wrapper/Wrapper';
import MediaQuery from 'react-responsive';
import { SectionBanner } from '../cart/CheckoutHelpers';
import { CartLineGroup, CartRetailSelect, Cost, Section } from '../cart/CartHelpers';
import { AuthenticationState } from 'react-aad-msal';
import { Loading } from '../state';
import OfflineUserSearch from './OfflineUserSearch';

var OfflineCart = function OfflineCart(props) {
  var _props$authentication = props.authenticationState,
      authenticationState = _props$authentication === void 0 ? AuthenticationState.Unauthenticated : _props$authentication,
      _props$getCart = props.getCart,
      getCart = _props$getCart === void 0 ? function () {
    return console.log("getCart");
  } : _props$getCart,
      _props$getShippingMod = props.getShippingModes,
      getShippingModes = _props$getShippingMod === void 0 ? function () {
    return console.log("getCart");
  } : _props$getShippingMod,
      _props$setShippingMod = props.setShippingMode,
      setShippingMode = _props$setShippingMod === void 0 ? function (shippingMode) {
    return console.log("shippingMode");
  } : _props$setShippingMod,
      _props$destructuredCa = props.destructuredCart,
      destructuredCart = _props$destructuredCa === void 0 ? {} : _props$destructuredCa,
      _props$shippingModes = props.shippingModes,
      shippingModes = _props$shippingModes === void 0 ? [] : _props$shippingModes,
      _props$shippingCosts = props.shippingCosts,
      shippingCosts = _props$shippingCosts === void 0 ? [] : _props$shippingCosts,
      _props$isRetail = props.isRetail,
      isRetail = _props$isRetail === void 0 ? false : _props$isRetail,
      _props$cost = props.cost,
      cost = _props$cost === void 0 ? {} : _props$cost,
      customerList = props.customerList,
      _props$getCusomerList = props.getCusomerList,
      getCusomerList = _props$getCusomerList === void 0 ? function () {
    return console.log('get list');
  } : _props$getCusomerList,
      _props$assignCustomer = props.assignCustomer,
      assignCustomer = _props$assignCustomer === void 0 ? function () {
    return console.log('assign Customer');
  } : _props$assignCustomer,
      _props$resetCustomerL = props.resetCustomerList,
      resetCustomerList = _props$resetCustomerL === void 0 ? function () {
    return console.log('reset customerlist');
  } : _props$resetCustomerL,
      assigned = props.assigned,
      _props$setLoaderAfter = props.setLoaderAfterAssign,
      setLoaderAfterAssign = _props$setLoaderAfter === void 0 ? function () {
    return console.log('loader after modal close');
  } : _props$setLoaderAfter,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading;
  var _destructuredCart$ret = destructuredCart.retailItems,
      retailItems = _destructuredCart$ret === void 0 ? [] : _destructuredCart$ret;
  var history = useHistory();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      sections = _useState2[0],
      setSections = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSearchModalOpen = _useState4[0],
      setIsSearchModalOpen = _useState4[1];

  useEffect(function () {
    getCart();
    getShippingModes();
    constructSections();
  }, []);
  var layout = {
    background: "white",
    padding: "medium"
  };

  var buttonClick = function buttonClick() {
    history.replace('/shop');
  };

  var constructSections = function constructSections() {
    var sections = ["1cart"];
    sections.push("2retail");
    setSections(sections);
  };

  var onHide = function onHide() {
    setIsSearchModalOpen(false);
  };

  var openUserSearchModal = function openUserSearchModal() {
    setIsSearchModalOpen(true);
  };

  var assignCust = function assignCust(customer) {
    setIsSearchModalOpen(false);
    assignCustomer(customer);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout,
    className: "cb-cart"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "8",
    className: "cb-cart__content-wrapper"
  }, /*#__PURE__*/React.createElement(SectionBanner, {
    value: "Cart",
    index: 0,
    activeCategoryIndex: 0
  }), /*#__PURE__*/React.createElement(Section, null, /*#__PURE__*/React.createElement(CartLineGroup, _extends({}, props, {
    offlineCart: true,
    items: retailItems,
    title: "Shop"
  }))), /*#__PURE__*/React.createElement(CartRetailSelect, _extends({}, props, {
    deliveryOptions: shippingModes,
    deliveryCosts: shippingCosts,
    title: "Retail",
    index: sections.indexOf("2retail")
  }))), isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "cb-l-container-wrapper--space"
  }, /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  })) : /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "4",
    className: "cb-cart__cost-wrapper"
  }, !assigned ? /*#__PURE__*/React.createElement(Cost, cost, authenticationState !== AuthenticationState.Authenticated &&
  /*#__PURE__*/
  // <StateButton className="cb-button-primary" id="signin" onClick={() => { signInClick(); signIn(); }}> Sign in</StateButton>}
  React.createElement(StateButton, {
    className: "cb-button-primary",
    id: "Search User",
    onClick: openUserSearchModal
  }, " Search Customer "), authenticationState !== AuthenticationState.Authenticated && /*#__PURE__*/React.createElement(RouterStateButton, {
    href: "/shop/checkout",
    className: "cb-button-secondary"
  }, " Continue as Guest")) : /*#__PURE__*/React.createElement(Cost, cost, /*#__PURE__*/React.createElement(RouterStateButton, {
    href: "/shop/checkout",
    className: "cb-button-secondary"
  }, " Checkout ")))), /*#__PURE__*/React.createElement(Modal, {
    className: "cb-menu-secondary",
    show: isSearchModalOpen
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("label", null, "Customer Search"), /*#__PURE__*/React.createElement("button", {
    className: "button cb-modal__close",
    onClick: onHide
  }, "x")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(OfflineUserSearch, {
    customerList: customerList,
    getCusomerList: getCusomerList,
    assignCust: assignCust,
    resetCustomerList: resetCustomerList,
    setLoaderAfterAssign: setLoaderAfterAssign
  }))))));
};

export default OfflineCart;